/**
 * Diccionarios de interfaz de la pantalla del agente.
 *
 * Los dos idiomas se empaquetan juntos: son unos pocos kilobytes y cargarlos
 * bajo demanda meteria un estado asincrono en el cambio de idioma a cambio de
 * nada.
 *
 * El MECANISMO --busqueda por clave, plural, clave ausente-- vive en
 * `traductor.ts`, que no depende de estos textos. Aqui solo estan los textos y
 * la eleccion de idioma. La pagina publica de alta tiene su propio diccionario y
 * usa el mismo mecanismo sin cargar este archivo: son dos bundles distintos
 * [frontend/perfil.mjs].
 *
 * [CLAUDE.md, Idioma] Aqui SOLO entra texto de interfaz y codigos estables. Los
 * literales del proveedor --`carrier_literal`, `descripcion_literal`,
 * `condicion_comercial`, `restriccion_mercancia`-- no pasan por este modulo en
 * ningun caso: se pintan tal como llegaron. `dom.ts` tiene una funcion aparte
 * para ellos, `literal()`, para que la diferencia sea visible en el codigo y no
 * dependa de que alguien se acuerde.
 */

import en from './i18n/en.json';
import es from './i18n/es.json';
import { crearTraductorDe, type Idioma, type Traductor } from './traductor';

export {
  crearTraductorDe,
  esIdioma,
  IDIOMA_POR_DEFECTO,
  IDIOMAS,
  nombreIdioma,
  type Idioma,
  type Traductor,
} from './traductor';

const DICCIONARIOS: Record<Idioma, unknown> = { es, en };

export function crearTraductor(idioma: Idioma): Traductor {
  return crearTraductorDe(DICCIONARIOS[idioma]);
}
